'use client';
import {QueryClient, QueryClientProvider} from '@sdk-mobile';

// Create a client
const queryClient = new QueryClient();

const QueryProvider = ({children}) => {
  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
};

export default QueryProvider;
